import { OrderAddressDto } from "@lib/ShiOneClient";
import { normalizeString } from "@features/orders-features/functions/helpers";

const joinDefinedValues = (
  separator: string,
  values: Array<string | undefined>,
): string =>
  values.filter((value): value is string => Boolean(value)).join(separator);

export default function getAddress(
  address?: OrderAddressDto,
): string[] | undefined {
  if (!address) return;

  const country = address.countryCode?.trim() || address.country?.trim() || "";
  const countryCode = country.length > 0 && country.length <= 3 ? country : undefined;
  const countryName = country.length > 3 ? country : undefined;

  const statePostalCountryCode = joinDefinedValues(" ", [
    normalizeString(address.stateProvince),
    normalizeString(address.postalCode),
    countryCode,
  ]);

  const cityStatePostalCountryCode = joinDefinedValues(", ", [
    normalizeString(address.city),
    normalizeString(address.county),
    statePostalCountryCode || undefined,
  ]);

  return [
    normalizeString(address.addressLine1),
    normalizeString(address.addressLine2),
    normalizeString(address.addressLine3),
    cityStatePostalCountryCode || undefined,
    countryName,
  ].filter((value): value is string => Boolean(value));
}
